import { createAsyncThunk } from '@reduxjs/toolkit';
import { createClientPortalChat } from 'services/pod';
import { IClientPortalChat, IFirstClientPortalChat } from '../../../services/pod/types';

interface IProps {
  id: number;
  payload: IFirstClientPortalChat;
}

export const ThunkCreateClientPortalChat = createAsyncThunk<
  IClientPortalChat,
  IProps,
  { rejectValue: Error }
>('clientPortalChats/createClientPortalChat', async ({ id, payload }, { rejectWithValue }) => {
  try {
    const { data } = await createClientPortalChat(id, payload);
    return data;
  } catch (error) {
    const { data } = error as {
      data: Error;
    };
    return rejectWithValue(data);
  }
});
